import React from 'react';
import PanelApp from './components/Panel/PanelApp';
import LandingApp from './pages/LandingApp';
import ChatbularisApp from './pages/ChatbularisApp';
import ResetPage from './pages/ResetPage';
import VerifyPage from './pages/VerifyPage';
import EstadoPublico from './pages/EstadoPublico';
import LegalPage from './pages/LegalPage';
import PlataformaConsola from './pages/PlataformaConsola';
import AsistenteLegal from './pages/AsistenteLegal/AsistenteLegal';
import WordApp from './pages/Word/WordApp';
import DriveApp from './pages/Drive/DriveApp';
import AprendePublico from './pages/AprendePublico';
import { esApex } from './utils/api';
import { fijarSeo } from './utils/seo';
import './styles/global.css';

// App independiente. Decide qué mostrar según el dominio:
//  - Dominio raíz (tabularis.cl)  → landing pública (presentación + registro + ingresar).
//  - Subdominio (estudio.tabularis.cl) → panel de gestión del estudio.
// Ruteo mínimo por path para las páginas de cuenta (enlaces de correo).
// Canónica o noindex, según la página (ver utils/seo).
fijarSeo();

const App: React.FC = () => {
  const path = window.location.pathname;
  if (path.startsWith('/reset')) return <ResetPage />;
  if (path.startsWith('/verificar')) return <VerifyPage />;
  if (path.startsWith('/estado')) return <EstadoPublico />;
  if (path.startsWith('/legal') || path.startsWith('/terminos') || path.startsWith('/privacidad')) return <LegalPage />;
  if (path.startsWith('/plataforma')) return <PlataformaConsola />;
  // El botón "Chatbularis IA" del panel abre esta ruta en una pestaña nueva. Hasta
  // ahora no existía acá y caía al panel, así que el botón no llevaba a ninguna
  // parte: la página vivía en svabogadas y nunca se migró.
  if (path.startsWith('/asistente')) return <AsistenteLegal />;
  // El panel del complemento de Word. Una sola dirección para todos los
  // estudios (la del manifiesto): el estudio se pide al entrar.
  if (path === '/word' || path.startsWith('/word/')) return <WordApp />;
  // La ventana que trae archivos de Google Drive. Una sola dirección para
  // todos los estudios, porque Google no acepta comodines: ver utils/drive.ts.
  if (path === '/drive' || path.startsWith('/drive/')) return <DriveApp />;
  // Página de Chatbularis solo, para los anuncios. Cuando exista chatbularis.cl
  // apunta acá mismo.
  if (esApex() && path.startsWith('/chatbularis')) return <ChatbularisApp />;
  // Las cápsulas sueltas, para mandar por correo. No se enlaza desde la portada.
  if (esApex() && (path === '/aprende' || path.startsWith('/aprende/'))) return <AprendePublico />;
  if (esApex()) return <LandingApp />;
  return <PanelApp />;
};

export default App;
